import { RetailMetrics } from "@technis/shared";
import { type RetailDataResult } from "src/typings";

import { useFirebaseRetailMultiDataHook } from "./useFirebaseRetailDataHook";
import { BEHAVIOR_DATA, COMFORT_DATA } from "./useHomepageV2Datas.constants";

export interface DatasResult {
  flowLiveData: Partial<RetailDataResult>;
  energyLiveData: Partial<RetailDataResult>;
  behaviorData: typeof BEHAVIOR_DATA;
  comfortData: typeof COMFORT_DATA;
  isFlowLiveDataLoading: boolean;
  isEnergyLiveDataLoading: boolean;
  isBehaviorDataLoading: boolean;
  isComfortDataLoading: boolean;
}

const BEEZI_ORG_ID = 744;
const BEEZI_INSTALL_ID = 1840;
const BEEZI_TOP_ZONE_ID = 3246;
const BEEZI_CHILD_ZONE_ID = 3247;

// Flow datas are faked with Beezi datas only (Prod ids)
const FLOW_LIVE_DATA_PARAMS = {
  retailMetrics: [RetailMetrics.INSIDE, RetailMetrics.AFFLUENCE_IN, RetailMetrics.DWELL],
  zoneIds: [BEEZI_CHILD_ZONE_ID],
  installationId: BEEZI_INSTALL_ID,
  organizationId: BEEZI_ORG_ID,
};

// Energies datas are faked with Beezi datas only (Prod ids)
const ENERGY_LIVE_DATA_PARAMS = {
  retailMetrics: [
    RetailMetrics.ELECTRICITY_CONSUMPTION_ON_DAY,
    RetailMetrics.ELECTRICITY_PRODUCTION_ON_DAY,
    RetailMetrics.WATER_CONSUMPTION_ON_DAY,
  ],
  zoneIds: [BEEZI_TOP_ZONE_ID],
  installationId: BEEZI_INSTALL_ID,
  organizationId: BEEZI_ORG_ID,
};

export const useHomepageV2Datas = (): DatasResult => {
  const { values: flowLiveData, loading: isFlowLiveDataLoading } = useFirebaseRetailMultiDataHook({
    ...FLOW_LIVE_DATA_PARAMS,
    skip: false,
  });

  const { values: energyLiveData, loading: isEnergyLiveDataLoading } = useFirebaseRetailMultiDataHook({
    ...ENERGY_LIVE_DATA_PARAMS,
    skip: false,
  });

  return {
    flowLiveData,
    energyLiveData,
    behaviorData: BEHAVIOR_DATA,
    comfortData: COMFORT_DATA,
    isFlowLiveDataLoading,
    isEnergyLiveDataLoading,
    isBehaviorDataLoading: false,
    isComfortDataLoading: false,
  };
};
